import React, { useEffect, useState } from 'react';
import styles from '../styles/termsOfUse.module.scss';
import { collection, getDocs } from "firebase/firestore";
import {db} from '../config/firebase';

function TermsOfUseTr() {
    const [termsOfUse, setTermsOfUse] = useState(null);

    useEffect(() => {
        fetchPost()
    }, [])

    const fetchPost = async () => {
       console.log('BURDA')
       const usersCollectionRef = collection(db, "Contracts");
        getDocs(usersCollectionRef)
            .then((querySnapshot)=>{               
                const newData = querySnapshot.docs.filter(x => x.id === 'Terms Of Use')
                if (newData.length > 0) {
                    setTermsOfUse(newData[0].data())
                    console.log('AAA', newData[0].data())
                }
                //     .map((doc) => ({...doc.data(), id:doc.id }));              
                // console.log(newData);
            })
            .catch(e => console.error('HATA', e))
       
    }

    return (
        <div>
            <div className={styles.header}>
                <div className={styles.header__content}>
                    <div>
                        <span className={styles.logo}>Ham Yap</span>
                    </div>
                </div>
            </div>

            <div className={styles.frame}>
                <div className={styles.container1}>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(0, 40)}</p>
                    </div>
                    <br/>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(41, 54)}</p>
                    </div>
                    <div className={styles.container1__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(55, 108)}</p>
                    </div>
                </div>
               
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(109, 1279)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(1280, 1918)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(1919, 2033)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(2034, 2411)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(2412, 3183)}</p>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        {/* <p>Kullanıcı içeriği ve intekarktif</p> */}
                        <p>{termsOfUse != null && termsOfUse.content.substring(3184, 3238)}</p>
                    </div>
                </div>
                    
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(3239, 3830)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(3831, 4089)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4090, 4349)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4350, 4639)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4640, 4801)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(4802, 5031)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5032, 5179)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5180, 5255)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5256, 5339)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5340, 5572)}</p>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5573, 5878)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(5879, 7675)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(7676, 8042)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(8042, 8791)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(8792, 9705)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(9706, 10583)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(10583, 10905)}</p>
                        <br/>
                    </div>
                </div>

                <div className={styles.containerTitle}>
                    <div className={styles.containerTitle__text1}>
                        {/* <p>Kullanıcı içeriği ve intekarktif</p> */}
                        <p>{termsOfUse != null && termsOfUse.content.substring(10906, 10921)}</p>
                    </div>
                </div>
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text1}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(10922, 11088)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11089, 11535)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11536, 11547)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11548, 11837)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(11838, 12430)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(12431, 12775)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(12776, 13185)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13186, 13507)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13508, 13940)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(13940, 14151)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(14152, 14480)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(14481, 15199)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15199, 15335)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15336, 15563)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15564, 15882)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(15883, 16095)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16096, 16434)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16435, 16993)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(16994, 17348)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(17349, 17684)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(17685, 17914)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(17915, 18074)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18075, 18376)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18377, 18632)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(18633, 19268)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(19269, 19441)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(19442, 19682)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(19683, 19819)}</p>
                        <br/>
                        <p>{termsOfUse != null && termsOfUse.content.substring(19820, 19997)}</p>
                        <br/>
                    </div>
                </div>
                <div className={styles.containerContent}>
                    <div className={styles.containerContent__text2}>
                        <p>{termsOfUse != null && termsOfUse.content.substring(19998, 20045)}</p>
                        <br/>
                    </div>
                </div>
            </div>
        </div>
      
    )
}

export default TermsOfUseTr;